import React from 'react';
import { Page, Stack } from '@nearst/ui';

import { useShop } from '@services/ShopProvider';

import DatePicker from '@components/DatePicker';
import InsightTeaserOverlay from '../components/InsightTeaserOverlay';
import UpgradeRequiredBanner from '@components/UpgradeRequiredBanner';

import FreeLocalListings from './FreeLocalListings';
import PopularProducts from './PopularProducts';
import ProductPageLinkingAnalytics from './ProductPageLinkingAnalytics';
import SwisScreenshot from './SwisScreenshot';

import styles from './SWIS.module.scss';

const SWIS = () => {
	const { shop } = useShop();

	return (
		<>
			<Page.Header>
				<h1>Local Listings</h1>
				<p>Understand the trends in your Google organic listings performance.</p>
				<DatePicker showComparison showInterval />
			</Page.Header>
			<Page.Section>
				{shop.plan === 'freemium' ? (
					<UpgradeRequiredBanner>
						Upgrade your plan to discover how your products are performing across your free local listings.
					</UpgradeRequiredBanner>
				) : null}
				{shop.plan === 'freemium' ? (
					<InsightTeaserOverlay>
						<div className={`${styles.container} ${styles.leftEmphasis} ${styles.teaser}`}>
							<FreeLocalListings teaser />
							<SwisScreenshot teaser />
						</div>
					</InsightTeaserOverlay>
				) : (
					<Stack>
						<div className={`${styles.container} ${styles.leftEmphasis}`}>
							<FreeLocalListings />
							<SwisScreenshot />
						</div>
						<PopularProducts />
						<ProductPageLinkingAnalytics shops={[shop]} />
					</Stack>
				)}
			</Page.Section>
		</>
	);
};

export default SWIS;
